var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCheckOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.58,28.27v16.35h28.38V28.27l-14.19-12.04L4.58,28.27Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3,4.89c-.09-.33-.25-.64-.51-.89-.26-.26-.58-.43-.92-.52-.2-.06-.4-.11-.62-.11h-10.65c-1.1,0-2,.89-2,2s.9,2,2,2h5.98l-8.49,8.49c-.78,.78-.78,2.05,0,2.83,.39,.39,.9,.59,1.41,.59s1.02-.2,1.41-.59l8.49-8.49v5.98c0,1.11,.9,2,2,2s2-.89,2-2V5.53c0-.23-.05-.44-.12-.65Z",
    fill: filledColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58,40.61h7.35c.11,0,.22,0,.33,.01h5.01c.11,0,.22-.01,.33-.01h7.35v-10.49l-10.19-8.65-10.19,8.65v10.49Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.58,28.27v16.35h28.38V28.27l-14.19-12.04L4.58,28.27Zm24.38,1.85v10.49h-7.35c-.11,0-.22,0-.33,.01h-5.01c-.11,0-.22-.01-.33-.01h-7.35v-10.49l10.19-8.65,10.19,8.65Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3,4.89c-.09-.33-.25-.64-.51-.89-.26-.26-.58-.43-.92-.52-.2-.06-.4-.11-.62-.11h-10.65c-1.1,0-2,.89-2,2s.9,2,2,2h5.98l-8.49,8.49c-.78,.78-.78,2.05,0,2.83,.39,.39,.9,.59,1.41,.59s1.02-.2,1.41-.59l8.49-8.49v5.98c0,1.11,.9,2,2,2s2-.89,2-2V5.53c0-.23-.05-.44-.12-.65Z",
    fill: outlineColor
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheckOut);
export default __webpack_public_path__ + "static/media/ico-check-out.dde678b9a8e089b55b4a49eb0f27e6e1.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;